import { AnyAction } from 'redux';
import { Document, DocumentDownloadActions, DocumentDownloadState } from './document-download-models';

const InitialState: DocumentDownloadState = {
	documents: null,
	documentsLoaded: false,
	requesting: false,
};



export const documentDownloadReducer = (state = InitialState, action: AnyAction): DocumentDownloadState => {

	switch (action.type) {

		case DocumentDownloadActions.SET_DOCUMENTS:
			return { documents: action.payload, documentsLoaded: true, requesting: false };
		case DocumentDownloadActions.GET_DOCUMENTS:
			return { ...state, requesting: true };
		case DocumentDownloadActions.SET_PRODUCT_SUMMARY:
			return { ...state, productSummary: action.payload, documentsLoaded: true };
		case DocumentDownloadActions.SET_GROUP_LIFE_CONTRACT_LIST:
			return { ...state, groupLifeContractList: action.payload, groupLifeContractListLoaded: true };
		default: return state;
	}
};


export const setDocuments = (documents: Document[]) => {
	return {
		type: DocumentDownloadActions.SET_DOCUMENTS,
		payload: documents,
	};

};

export const getDocuments = () => {
	return {
		type: DocumentDownloadActions.GET_DOCUMENTS,
	};

};


export const setProductSummary = (data) => {
	return {
		type: DocumentDownloadActions.SET_PRODUCT_SUMMARY,
		payload: data,
	};

};

export const setGroupLifeContractList = (data) => {
	return {
		type: DocumentDownloadActions.SET_GROUP_LIFE_CONTRACT_LIST,
		payload: data,
	};

};
